import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import Settings, { SettingsButton } from './Settings';

function Header() {
  const [settingsOpen, setSettingsOpen] = useState(false);

  const handleOpenSettings = () => {
    setSettingsOpen(true);
  };

  const handleCloseSettings = () => {
    setSettingsOpen(false);
  };

  return (
    <>
      <AppBar position="static" sx={{ mb: 3 }}>
        <Toolbar>
          <CodeIcon sx={{ mr: 2 }} />
          <Typography variant="h6" component="div">
            CodeFix Battle
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Typography variant="subtitle1" color="inherit" sx={{ mr: 2 }}>
            AI代码诊所对战版
          </Typography>
          <SettingsButton onClick={handleOpenSettings} />
        </Toolbar>
      </AppBar>
      
      <Settings open={settingsOpen} onClose={handleCloseSettings} />
    </>
  );
}

export default Header; 